import { Anchor, Badge, Box, Card, Image, Stack, Text } from '@mantine/core';
import { useParams } from 'react-router';

const ProductCard = ({ product }) => {
  const { accountId, domainId } = useParams();

  if (product === undefined) {
    return '';
  }

  const href = `#/accounts/${accountId}/domains/${domainId}/products/${product.id}`;

  return (
    <Card padding="md" mb="md">
      <Stack gap="xs" align="center">
        <Box style={{ width: '100%', maxWidth: 200, aspectRatio: '1', overflow: 'hidden' }}>
          <a href={href}>
            <Image src={product.imageUrl} alt={product.name} referrerPolicy="no-referrer" fit="contain" h={200} />
          </a>
        </Box>

        <Stack gap={4} align="center">
          <Text size="xs" c="dimmed">
            {product.id}
          </Text>
          <Text size="sm" fw={600} ta="center" lineClamp={2} style={{ minHeight: 40 }}>
            <Anchor href={href} c="inherit">
              {product.name}
            </Anchor>
          </Text>
          {product.available ? (
            <Badge color="green" variant="light" size="sm">
              In stock
            </Badge>
          ) : (
            <Badge color="red" variant="light" size="sm">
              Out of stock
            </Badge>
          )}

          <Text size="sm" fw={500}>
            {product.price + ' ' + product.currency}
          </Text>
        </Stack>
      </Stack>
    </Card>
  );
};

export default ProductCard;
